var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", [_vm._v("ИД *")]),
              _c("v-select", {
                attrs: {
                  outlined: "",
                  "item-text": "slotId",
                  "item-value": "slotId",
                  "hide-details": "",
                  dense: "",
                  "return-object": "",
                  value: _vm.changeAdPlacement,
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  items: _vm.adPlacements,
                },
                on: {
                  input: function ($event) {
                    return _vm.changeListItemHandler($event)
                  },
                },
              }),
              _c("ErrorMessage", {
                attrs: { message: _vm.errorMessages.text },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.changeAdPlacement
        ? _c(
            "v-row",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("span", [_vm._v("Заголовок")]),
                      _c("v-text-field", {
                        attrs: { disabled: "", outlined: "" },
                        model: {
                          value: _vm.changeAdPlacement.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.changeAdPlacement, "title", $$v)
                          },
                          expression: "changeAdPlacement.title",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("span", [_vm._v("Ширина блока")]),
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          outlined: "",
                          "error-messages": _vm.errorMessages.width,
                        },
                        model: {
                          value: _vm.changeAdPlacement.width,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.changeAdPlacement,
                              "width",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "changeAdPlacement.width",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("span", [_vm._v("Высота блока")]),
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          outlined: "",
                          "error-messages": _vm.errorMessages.height,
                        },
                        model: {
                          value: _vm.changeAdPlacement.height,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.changeAdPlacement,
                              "height",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "changeAdPlacement.height",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }